const X_HOSTS = new Set(["x.com", "twitter.com"]);
const RESERVED_X_PATHS = new Set([
  "compose",
  "explore",
  "hashtag",
  "home",
  "i",
  "intent",
  "messages",
  "search",
  "share",
]);

export function twitterSiteFromUrl(value: string | null | undefined) {
  const cleaned = value?.trim();
  if (!cleaned) return undefined;

  try {
    const url = new URL(cleaned);
    const host = url.hostname.toLowerCase().replace(/^www\./, "");
    if (url.protocol !== "https:" || !X_HOSTS.has(host)) return undefined;

    const handle = url.pathname.split("/").filter(Boolean)[0];
    if (
      !handle ||
      RESERVED_X_PATHS.has(handle.toLowerCase()) ||
      !/^[A-Za-z0-9_]{1,50}$/.test(handle)
    ) {
      return undefined;
    }
    return `@${handle}`;
  } catch {
    return undefined;
  }
}
